import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import { MenuItem, Modal, TextField } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import GochiKidReceiptTable from '../organisms/GochiKidReceiptTable';
import GochiKidReceiptApprovalModal from '../organisms/GochiKidReceiptApprovalModal';
import {
  getGochiKidReceiptDetail,
  getGochiKidReceiptList,
  confirmReceipt,
  GET_GOCHI_KID_RECEIPT_DETAIL_SUCCESS,
  CONFIRM_RECEIPT_GOCHI_KID_SUCCESS
} from '../../actions/GochiKidReceipt';
import GochiKidReceiptApprovalConfirmModal from '../../components/molecules/GochiKidReceiptApprovalConfirmModal';

const styles = theme => ({
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '400px',
    marginRight: 25
  },
  buttonGroupLeft: {
    textAlign: 'left',
    marginTop: 25
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  modal: {
    maxWidth: 880,
    margin: 'auto',
    padding: '15% 12px 5%'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const gochiKidReceiptStatusArr = [
  { label: '', name: '選択なし' },
  { label: 1, name: '承認済み' },
  { label: 2, name: '承認保留' },
  { label: 3, name: '承認待ち' },
  { label: 4, name: '非承認' }
];

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getGochiKidReceiptList,
          getGochiKidReceiptDetail,
          confirmReceipt
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('openApprovalModal', 'updateOpenApprovalModal', false),
  withState(
    'openApprovalConfirmModal',
    'updateOpenApprovalConfirmModal',
    false
  ),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('receiptStatus', 'setReceiptStatus', ''),
  withState('userId', 'setUserId', ''),
  withState('userName', 'setUserName', ''),
  withState('receiptSendDate', 'setReceiptSendDate', ''),
  withState('shopId', 'setShopId', ''),
  withState('shopName', 'setShopName', ''),
  withState('groupName', 'setGroupName', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('listReceipt', 'setlistReceipt', []),
  withState('totalCount', 'setTotalCount', 0),
  withState('offset', 'setOffset', 0),
  withState('receiptSelected', 'setReceiptSelected', null),
  withState('statusReceiptSelected', 'setStatusReceiptSelected', null),
  withState(
    'isUpdateStatusReceiptSuccess',
    'setIsUpdateStatusReceiptSuccess',
    false
  ),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangePage: props => async (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        status: props.receiptStatus,
        userId: props.userId,
        userName: props.userName,
        receiptDate: props.receiptSendDate,
        shopId: props.shopId,
        shopName: props.shopName,
        groupName: props.groupName,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getGochiKidReceiptList(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.setlistReceipt(data.payload.receipts);
          props.setTotalCount(data.payload.totalCount);
          props.setOffset(data.payload.offset);
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('エラーが発生しました。');
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.handleChangePage(
        null,
        this.props.page,
        this.props.rowsPerPage
      );
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleChangePage,
    account,
    actions,
    checkSession,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    receiptStatus,
    setReceiptStatus,
    userId,
    setUserId,
    userName,
    setUserName,
    receiptSendDate,
    setReceiptSendDate,
    shopId,
    setShopId,
    shopName,
    setShopName,
    groupName,
    setGroupName,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    page,
    setRowsPerPage,
    listReceipt,
    totalCount,
    offset,
    receiptSelected,
    setReceiptSelected,
    openApprovalModal,
    updateOpenApprovalModal,
    statusReceiptSelected,
    setStatusReceiptSelected,
    openApprovalConfirmModal,
    updateOpenApprovalConfirmModal,
    isUpdateStatusReceiptSuccess,
    setIsUpdateStatusReceiptSuccess
  }) => {
    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);

      if (isUpdateStatusReceiptSuccess) {
        handleChangePage(null, page, limitNum);
        setIsUpdateStatusReceiptSuccess(false);
      }
    };

    const handleOpenReceiptDetail = async receiptId => {
      updateLoading(true);
      updateOpenProgress(true);
      await actions.getGochiKidReceiptDetail(receiptId).then(response => {
        checkSession(response);
        if (response.type === GET_GOCHI_KID_RECEIPT_DETAIL_SUCCESS) {
          setReceiptSelected(response.payload);
          setStatusReceiptSelected(response.payload.status);
          updateOpenApprovalModal(true);
          updateLoading(false);
          updateOpenProgress(false);
        } else {
          setReceiptSelected(null);
          setResultMessage('エラーが発生しました。');
          updateLoading(false);
        }
      });
    };

    const handleConfirmChangeStatus = () => {
      updateOpenApprovalModal(false);
      updateOpenApprovalConfirmModal(true);
    };

    const handleCancelChangeStatus = () => {
      updateOpenApprovalModal(false);
      setReceiptSelected(null);
      setStatusReceiptSelected(null);
    };

    const handleSubmitChangeStatus = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      updateLoading(true);
      updateOpenProgress(true);
      const params = {
        gochiKidReceiptId: receiptSelected.id,
        status: statusReceiptSelected
      };
      await actions.confirmReceipt(params).then(response => {
        checkSession(response);
        if (response.type === CONFIRM_RECEIPT_GOCHI_KID_SUCCESS) {
          setIsUpdateStatusReceiptSuccess(true);
          updateOpenApprovalConfirmModal(false);
          updateLoading(false);
          setResultMessage('更新を完了しました。');
        } else {
          setResultMessage('エラーが発生しました。');
          updateLoading(false);
        }
      });
    };

    const handleCancelConfirmChangeStatus = () => {
      updateOpenApprovalConfirmModal(false);
      updateOpenApprovalModal(true);
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            こどもごちめし レシート利用履歴
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              <TextField
                select
                label="承認状況"
                className={classes.textField}
                type="search"
                margin="normal"
                value={receiptStatus}
                onChange={e => {
                  setReceiptStatus(e.target.value);
                }}
                InputLabelProps={{
                  shrink: true
                }}
              >
                {gochiKidReceiptStatusArr.map(item => {
                  return (
                    <MenuItem key={item.label} value={item.label}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                label="利用者ID"
                placeholder="利用者ID"
                type="search"
                className={classes.textField}
                margin="normal"
                value={userId}
                onChange={e => {
                  setUserId(e.target.value);
                }}
              />
              <TextField
                label="利用者名"
                placeholder="利用者名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={userName}
                onChange={e => {
                  setUserName(e.target.value);
                }}
              />
              <TextField
                label="レシート登録日時"
                type="date"
                placeholder="レシート登録日時"
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={receiptSendDate}
                onChange={e => {
                  setReceiptSendDate(e.target.value);
                }}
                onBlur={e => {
                  if (!receiptSendDate) {
                    e.target.value = '';
                    setReceiptSendDate('');
                  }
                }}
              />
            </div>
            <div>
              <TextField
                label="利用店舗ID"
                placeholder="利用店舗ID"
                type="search"
                className={classes.textField}
                margin="normal"
                value={shopId}
                onChange={e => {
                  setShopId(e.target.value);
                }}
              />
              <TextField
                label="利用店舗名"
                placeholder="利用店舗名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={shopName}
                onChange={e => {
                  setShopName(e.target.value);
                }}
              />
              <TextField
                label="利用グループ名"
                placeholder="利用グループ名"
                type="search"
                className={classes.textField}
                margin="normal"
                value={groupName}
                onChange={e => {
                  setGroupName(e.target.value);
                }}
              />
            </div>
            <div className={classes.buttonGroupLeft}>
              <SearchButton onClickAction={searchAction} />
            </div>
          </div>
          {openTable && (
            <GochiKidReceiptTable
              handleChangePage={handleChangePage}
              selectedPage={page}
              setRowsPerPage={setRowsPerPage}
              listReceipt={listReceipt}
              totalCount={totalCount}
              offset={offset}
              handleOpenReceiptDetail={handleOpenReceiptDetail}
            />
          )}
          <ProgressDialog openProgress={openProgress} loading={loading} />
        </Paper>

        <Modal open={openApprovalModal}>
          <GochiKidReceiptApprovalModal
            receipt={receiptSelected}
            handleChangePage={handleChangePage}
            statusReceiptSelected={statusReceiptSelected}
            setStatusReceiptSelected={setStatusReceiptSelected}
            confirmAction={handleConfirmChangeStatus}
            cancelAction={handleCancelChangeStatus}
          />
        </Modal>

        <Modal open={openApprovalConfirmModal} className={classes.modal}>
          <GochiKidReceiptApprovalConfirmModal
            receipt={receiptSelected}
            statusReceiptSelected={statusReceiptSelected}
            handleCancel={handleCancelConfirmChangeStatus}
            handleSubmit={handleSubmitChangeStatus}
          />
        </Modal>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
